function getAgeOptions(from, to) {
  var opts = [];
  for (var i = from ; i <= to ; i++) {
    opts.push({
      label: i + ' Jahre',
      value: i
    })
  }
  return opts;
}

module.exports = {
  sex: {
    label: 'Geschlecht',
    required: true,
    options: [
      {
        label: 'Männlich',
        // itemnum: '',
        value: 'male'
      },
      {
        label: 'Weiblich',
        // itemnum: '',
        value: 'female'
      }
    ]
  },
  age: {
    label: 'Alter',
    required: true,
    options: getAgeOptions(4, 99)
  }
}
